import { Injectable, signal } from '@angular/core';

import { Attachment } from '@core/attachments-types';

@Injectable({
  providedIn: 'root',
})
export class EmailAttachmentsService {
  public currentAttachments = signal<Attachment[]>([]);

  public setCurrentAttachments(attachments: Attachment[]): void {
    this.currentAttachments.set(attachments);
  }
}
